import { render } from "./PremiumFeatureRoute.vue?vue&type=template&id=166bc604&scoped=true"
import script from "./PremiumFeatureRoute.vue?vue&type=script&lang=js"
export * from "./PremiumFeatureRoute.vue?vue&type=script&lang=js"

import "./PremiumFeatureRoute.vue?vue&type=style&index=0&id=166bc604&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166bc604"]])

export default __exports__